import React, { useEffect, useState } from "react";
import {
  Box,
  ToggleButtonGroup,
  ToggleButton,
  Avatar,
  Typography,
  IconButton,
  ListItem,
  List,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import VisualizacaoToggle from "./VisualizacaoToggle";
import UserCard from "./UserCard";
import {
  deleteUser,
  getClientByCnpj,
  getUsersByGroup,
} from "../services/clientService";
import { toast } from "react-toastify";
import { DeleteDialog } from "./DeleteDialog";

interface UsersViewerProps {
  list?: any[];
  searchText: string;
}

const UsersViewer: React.FC<UsersViewerProps> = ({ list, searchText }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedTab, setSelectedTab] = useState("clientes");
  const [visualizacao, setVisualizacao] = useState<"card" | "list">(
    isMobile ? "card" : "list"
  );
  const [users, setUsers] = useState<any>([]);
  const [clientMap, setClientMap] = useState<Record<string, string>>({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]);
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);
  const [selectedUser, setSelectedUser] = useState<any>(null);

  const handleRemoveUser = async (email: string, group: number) => {
    try {
      await deleteUser(email);
      await fetchUsersByGroup(group);
    } catch (err) {
      console.error("Erro ao buscar deletar usuário:", err);
    }
  };

  const fetchUsersByGroup = async (group: any) => {
    try {
      const data = await getUsersByGroup(group);
      setUsers(data);
    } catch (error) {
      console.error("Erro ao buscar usuários por grupo:", error);
    }
  };

  const tabMap: Record<string, number> = {
    admin: 1,
    analistas: 2,
    clientes: 3,
  };

  const displayMap: Record<number, string> = {
    1: "Admin",
    2: "Analista",
    3: "Cliente",
  };

  useEffect(() => {
    fetchUsersByGroup(tabMap[selectedTab]);
  }, [selectedTab]);

  const handleTabChange = (
    event: React.MouseEvent<HTMLElement>,
    newTab: string
  ) => {
    if (newTab !== null) {
      setSelectedTab(newTab);
    }
  };

  const fetchClientInfo = async (cnpj: string) => {
    try {
      if (cnpj === "05.533.354/0001-15") {
        setClientMap((prev) => ({
          ...prev,
          [cnpj]: "BRAXCOM SERVICOS ADUANEIROS E CONSULTORIA TECNICA LTDA",
        }));
      } else {
        const data = await getClientByCnpj(cnpj);
        const nomeCurto = data?.NOME || "Desconhecido";

        setClientMap((prev) => ({ ...prev, [cnpj]: nomeCurto }));
      }
    } catch (err) {
      toast.error("Erro ao buscar empresa associada!");
      console.error("Erro ao buscar empresa associada:", err);
      setClientMap((prev) => ({ ...prev, [cnpj]: "--" }));
    }
  };

  useEffect(() => {
    const cnpjs = users.map((u: any) => u["custom:cnpj"]).filter(Boolean);

    const uniqueCnpjs: string[] = [];
    const seen = new Set();

    for (const cnpj of cnpjs) {
      if (!seen.has(cnpj)) {
        seen.add(cnpj);
        uniqueCnpjs.push(cnpj);
      }
    }

    uniqueCnpjs.forEach(fetchClientInfo);
  }, [users, selectedTab]);

  const filterUsers = () => {
    const filtered = users.filter((user: any) => {
      if (!user.name) return false;

      const userName = `${user.name.split(" ")[0]} ${user.name
        .split(" ")
        .slice(1)
        .join(" ")}`;
      return userName.toLowerCase().includes(searchText.toLowerCase());
    });
    setFilteredUsers(filtered);
  };
  const handleDebouncedToast = () => {
    if (timer) {
      clearTimeout(timer);
    }

    const newTimer = setTimeout(() => {
      if (filteredUsers.length === 0 && searchText) {
        toast.info("Não há nenhum usuário com esse nome nesse grupo!");
      }
    }, 500);

    setTimer(newTimer);
  };

  useEffect(() => {
    filterUsers();
  }, [searchText, users]);

  useEffect(() => {
    handleDebouncedToast();
  }, [filteredUsers]);

  // useEffect(() => {
  //   const mockUsers = [
  //     {
  //       name: "João da Silva",
  //       email: "joao@example.com",
  //       picture: "",
  //       "custom:cnpj": "12.345.678/0001-90",
  //     },
  //     {
  //       name: "Maria Oliveira",
  //       email: "maria@example.com",
  //       picture: "",
  //       "custom:cnpj": "05.533.354/0001-15",
  //     },
  //     {
  //       name: "Carlos Souza",
  //       email: "carlos@example.com",
  //       picture: "",
  //       "custom:cnpj": "99.999.999/0001-99",
  //     },
  //     {
  //       name: "Carlos Souza",
  //       email: "carlos@example.com",
  //       picture: "",
  //       "custom:cnpj": "99.999.999/0001-99",
  //     },
  //     {
  //       name: "Carlos Souza",
  //       email: "carlos@example.com",
  //       picture: "",
  //       "custom:cnpj": "99.999.999/0001-99",
  //     },
  //     {
  //       name: "Carlos Souza",
  //       email: "carlos@example.com",
  //       picture: "",
  //       "custom:cnpj": "99.999.999/0001-99",
  //     },
  //     {
  //       name: "Carlos Souza",
  //       email: "carlos@example.com",
  //       picture: "",
  //       "custom:cnpj": "99.999.999/0001-99",
  //     },
  //     {
  //       name: "Carlos Souza",
  //       email: "carlos@example.com",
  //       picture: "",
  //       "custom:cnpj": "99.999.999/0001-99",
  //     },
  //     {
  //       name: "Carlos Souza",
  //       email: "carlos@example.com",
  //       picture: "",
  //       "custom:cnpj": "99.999.999/0001-99",
  //     },
  //     {
  //       name: "Carlos Souza",
  //       email: "carlos@example.com",
  //       picture: "",
  //       "custom:cnpj": "99.999.999/0001-99",
  //     },
  //     {
  //       name: "Carlos Souza",
  //       email: "carlos@example.com",
  //       picture: "",
  //       "custom:cnpj": "99.999.999/0001-99",
  //     },
  //     {
  //       name: "Carlos Souza",
  //       email: "carlos@example.com",
  //       picture: "",
  //       "custom:cnpj": "99.999.999/0001-99",
  //     },
  //     {
  //       name: "Carlos Souza",
  //       email: "carlos@example.com",
  //       picture: "",
  //       "custom:cnpj": "99.999.999/0001-99",
  //     },
  //     {
  //       name: "Carlos Souza",
  //       email: "carlos@example.com",
  //       picture: "",
  //       "custom:cnpj": "99.999.999/0001-99",
  //     },
  //   ];
  //   setUsers(mockUsers);
  // }, [selectedTab]);

  return (
    <>
      <Box
        sx={{
          p: 3,
          border: "1px solid #0A0C33",
          borderRadius: "17px",
          height: "80vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 3,
            alignItems: "center",
          }}
        >
          <ToggleButtonGroup
            value={selectedTab}
            exclusive
            onChange={handleTabChange}
            aria-label="user type"
            sx={{
              gap: 2,
              "& .MuiToggleButton-root": {
                borderRadius: "25px",
                border: "1px solid #326AFD",
              },
            }}
          >
            <ToggleButton
              value="clientes"
              sx={{
                bgcolor: selectedTab === "clientes" ? "#326AFD" : "white",
                color: selectedTab === "clientes" ? "white" : "#326AFD",
                "&:hover": {
                  bgcolor:
                    selectedTab === "clientes" ? "#326AFD" : "transparent",
                },
                "&.Mui-selected": {
                  bgcolor: "#326AFD !important",
                  color: "white",
                  "&:hover": {
                    bgcolor: "#326AFD",
                  },
                },
                borderRadius: "25px",
                border: "1px solid #326AFD",
                width: {
                  xs: "auto",
                  sm: "auto",
                  md: "200px",
                },
                height: "50px",
                fontSize: "16px",
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Clientes
            </ToggleButton>
            <ToggleButton
              value="analistas"
              sx={{
                bgcolor: selectedTab === "analistas" ? "#326AFD" : "white",
                color: selectedTab === "analistas" ? "white" : "#326AFD",
                "&:hover": {
                  bgcolor:
                    selectedTab === "analistas" ? "#326AFD" : "transparent",
                },
                "&.Mui-selected": {
                  bgcolor: "#326AFD !important",
                  color: "white",
                  "&:hover": {
                    bgcolor: "#326AFD",
                  },
                },
                borderRadius: "25px",
                border: "1px solid #326AFD",
                width: {
                  xs: "auto",
                  sm: "auto",
                  md: "200px",
                },
                height: "50px",
                fontSize: "16px",
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Analistas
            </ToggleButton>
            <ToggleButton
              value="admin"
              sx={{
                bgcolor: selectedTab === "admin" ? "#326AFD" : "white",
                color: selectedTab === "admin" ? "white" : "#326AFD",
                "&:hover": {
                  bgcolor: selectedTab === "admin" ? "#326AFD" : "transparent",
                },
                "&.Mui-selected": {
                  bgcolor: "#326AFD !important",
                  color: "white",
                  "&:hover": {
                    bgcolor: "#326AFD",
                  },
                },
                borderRadius: "25px",
                border: "1px solid #326AFD",
                width: {
                  xs: "auto",
                  sm: "auto",
                  md: "200px",
                },
                height: "50px",
                fontSize: "16px",
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              {isMobile ? "Admins" : "Administradores"}
            </ToggleButton>
          </ToggleButtonGroup>

          {!isMobile && <VisualizacaoToggle onChange={setVisualizacao} />}
        </Box>

        {visualizacao === "list" && filteredUsers.length > 0 && (
          <>
            <List
              sx={{
                height: "90%",
                overflowY: "auto",
                bgcolor: "background.paper",
                "&::-webkit-scrollbar": {
                  width: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#555",
                  },
                },
              }}
            >
              {filteredUsers?.map((user: any, index: number) => {
                const [firstName = "", ...rest] =
                  user.name?.trim()?.split(" ") ?? [];
                const lastName = rest.join(" ");

                return (
                  <div key={index}>
                    <ListItem
                      sx={{
                        mb: 2,
                        p: 0,
                        bgcolor: "#F8F9FA",
                        borderRadius: "12px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          width: "100%",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          sx={{
                            width: 24,
                            height: 59,
                            bgcolor: "#90EE90",
                            borderRadius: "12px 0px 0px 12px",
                          }}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            flex: 1,
                            px: 3,
                          }}
                        >
                          <Avatar
                            sx={{
                              width: 40,
                              height: 40,
                              backgroundColor: user.picture
                                ? "transparent"
                                : "#326AFD",
                              color: user.picture ? "inherit" : "#FFFFFF",
                              fontWeight: user.picture ? "normal" : "bold",
                              fontSize: "1rem",
                            }}
                            src={user.picture || undefined}
                          >
                            {!user.picture &&
                              `${firstName[0] || ""}${lastName[0] || ""}`}
                          </Avatar>

                          <Box
                            sx={{
                              flexBasis: "22%",
                              height: "auto",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                            }}
                          >
                            <Typography>
                              {firstName} <strong>{lastName}</strong>
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              width: "2px",
                              height: "44px",
                              bgcolor: "#CBCBCB",
                              opacity: 1,
                              mx: 1,
                            }}
                          />

                          <Typography sx={{ fontWeight: "bold" }}>
                            Associado:{" "}
                            {clientMap[user["custom:cnpj"]]
                              ?.split(" ")
                              .slice(0, 2)
                              .join(" ") || "BRAXCOM SERVICOS"}
                          </Typography>

                          <Typography sx={{ color: "text.secondary", ml: 4 }}>
                            Matrícula: #{index + 1}
                          </Typography>

                          <Typography sx={{ color: "text.secondary", ml: 4 }}>
                            Permissões: {displayMap[tabMap[selectedTab]]}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", gap: 1, pr: 2 }}>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setSelectedUser(user);
                              setConfirmationModal(true);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </ListItem>
                  </div>
                );
              })}
            </List>
            {confirmationModal && selectedUser && (
              <DeleteDialog
                open={confirmationModal}
                onClose={() => {
                  setConfirmationModal(false);
                  setSelectedUser(null);
                }}
                onDelete={() => {
                  handleRemoveUser(selectedUser.email, tabMap[selectedTab]);
                  setConfirmationModal(false);
                  setSelectedUser(null);
                }}
                userName={`${
                  selectedUser.name.split(" ")[0]
                } ${selectedUser.name.split(" ").slice(1).join(" ")}`}
              />
            )}
          </>
        )}
        {visualizacao === "card" && filteredUsers.length > 0 && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(auto-fill, minmax(280px, 1fr))",
                sm: "repeat(auto-fill, minmax(280px, 1fr))",
                md: "repeat(auto-fill, minmax(400px, 1fr))",
              },
              gap: 3,
              overflowY: "auto",
              flex: 1,
              height: "90%",
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "10px",
                "&:hover": {
                  background: "#555",
                },
              },
            }}
          >
            {filteredUsers?.map((user: any, index) => (
              <UserCard
                permission={displayMap[tabMap[selectedTab]]}
                userId={index}
                key={user.sub}
                user={user}
                onRemove={() => {
                  handleRemoveUser(user.email, tabMap[selectedTab]);
                }}
              />
            ))}
          </Box>
        )}

        {filteredUsers.length === 0 && (
          <div style={{ textAlign: "left" }}>Nenhum usuário encontrado.</div>
        )}
      </Box>
    </>
  );
};

export default UsersViewer;
